import React, { useState } from "react";
import { sampleSize } from "lodash";
import _QUESTIONS from "./questions.json";
import { QUIZ_LENGTH } from "../../utils/consts";

import QRCode from "react-qr-code";
import Confetti from "react-confetti";
import useWindowSize from "react-use/lib/useWindowSize";

interface Question {
  question: string;
  answers: string[];
  correct: number;
  explanation: string;
  source: string;
}

const QUESTIONS = _QUESTIONS as Question[];

interface GameScreenProps {
  selectTab: (index: number) => void;
}

export const GameScreen: React.FC<GameScreenProps> = ({ selectTab }) => {
  const { width, height } = useWindowSize();

  const [questions, setQuestions] = useState<Question[]>([]);
  const [questionIndex, setQuestionIndex] = useState(0); // index of current question
  const [attempted, setAttempted] = useState<number[]>([]); // options clicked on
  const [showCorrect, setShowCorrect] = useState(false);
  const [showEndScreen, setShowEndScreen] = useState(false);
  const [confettiNumPieces, setConfettiNumPieces] = useState(200);
  const [score, setScore] = useState(0);

  const currentQuestion = questions[questionIndex];

  const returnToMap = () => {
    selectTab(0);
  };

  const startGame = () => {
    setQuestionIndex(0);
    setAttempted([]);
    setQuestions(sampleSize(QUESTIONS, QUIZ_LENGTH));
    setShowCorrect(false);
    setConfettiNumPieces(200);
    setScore(0);
  };

  /** has the player found the correct answer? */
  const foundAnswer = () => attempted.includes(currentQuestion.correct);

  // called when clicking on an option
  const makeAttempt = async (index: number) => {
    if (foundAnswer()) {
      return;
    }
    if (index == currentQuestion.correct) {
      if (attempted.length == 0) setScore(score + 1);

      setShowCorrect(true);
      await delay(850);
      setShowCorrect(false);
    }
    if (!showCorrect) {
      setAttempted([...attempted, index]);
    }
  };

  const delay = (ms: number) => new Promise((res) => setTimeout(res, ms));

  const nextQuestion = () => {
    if (!foundAnswer()) return;

    if (showEndScreen) {
      setQuestions([]);
      setConfettiNumPieces(200);
      setShowEndScreen(false);
      return;
    }

    // finish
    if (questionIndex === QUIZ_LENGTH - 1) {
      // setQuestions([]);
      setShowEndScreen(true);
      void delay(3000).then(() => setConfettiNumPieces(0));

      return;
    }

    setAttempted([]);
    setQuestionIndex(questionIndex + 1);
  };

  return (
    <div
      style={{
        marginLeft: "15%",
        marginRight: "15%",
        width: "100%",
        // marginTop: "100px",
      }}
    >
      {questions.length > 0 ? (
        // questions and answers
        <div style={{}}>
          {showEndScreen ? (
            <div style={{ textAlign: "center" }}>
              <Confetti
                width={width}
                height={height}
                numberOfPieces={confettiNumPieces}
              />
              <div
                style={{
                  textAlign: "center",
                  // marginTop: "275px",
                }}
              >
                <div
                  style={{
                    width: "200px",
                    height: "200px",
                    borderRadius: "50%",
                    background: "rgba(0, 105, 62, 0.40)",
                    boxShadow: "5px 5px 10px 0px rgba(0, 0, 0, 0.25)",
                    marginLeft: "50%",

                    transform: "translateX(-50%)",
                  }}
                >
                  <h2
                    style={{
                      fontSize: "50px",
                      paddingTop: "65px",
                      color: "#00693E",
                    }}
                  >
                    {score}/10
                  </h2>
                </div>
                <h1
                  className="font-ruzicka"
                  style={{
                    fontWeight: 800,
                    fontSize: "42px",
                    marginBottom: "50px",
                  }}
                >
                  Thanks for playing!
                </h1>
                <button
                  className="font-national"
                  style={{
                    borderRadius: "15px",
                    border: "2px solid #002b52",
                    color: "#003C73",
                    height: "65px",
                    width: "300px",
                    marginRight: "20px",
                    fontWeight: 500,
                    fontSize: "20px",
                  }}
                  onClick={returnToMap}
                >
                  Return to Campus Map
                </button>
                <button
                  className="font-national"
                  style={{
                    borderRadius: "15px",
                    background: "#003C73",
                    color: "white",
                    height: "65px",
                    width: "300px",
                    marginLeft: "20px",
                    fontWeight: 500,
                    fontSize: "20px",
                    border: "2px solid #002B52",
                  }}
                  onClick={nextQuestion}
                >
                  Play Again
                </button>
              </div>
            </div>
          ) : (
            <>
              {/* progress bar */}
              <div
                style={{
                  textAlign: "center",
                  top: "100px",
                  position: "absolute",
                  marginLeft: "auto",
                  marginRight: "auto",
                  left: 0,
                  right: 0,
                }}
              >
                {Array.from({ length: questions.length }).map((_, index) => (
                  <img
                    style={{
                      width: "50px",
                      marginLeft: "5px",
                      marginRight: "5px",
                    }}
                    src={
                      index > questionIndex
                        ? "/lightbulbs/unlit.png"
                        : "/lightbulbs/lit.png"
                    }
                    key={index}
                  />
                ))}
              </div>
              {/* <div
            style={{
              width: "100%",
              borderRadius: "20px",
              backgroundColor: "#D9D9D9",
              height: "30px",
            }}
          >
            <div
              style={{
                width: `${((questionIndex + 1) / QUIZ_LENGTH) * 100}%`,
                backgroundColor: "#003C73",
                borderRadius: "20px",
                textAlign: "center",
                fontWeight: "bold",
                // padding: "0.1px",
                height: "100%",
                transition: "width 0.4s ease-out", // Add this line for smooth transition
              }}
            ></div>
          </div> */}

              {/* question, answer options */}

              {/* answer explanation and next question button */}
              {foundAnswer() ? (
                <div
                  style={{
                    marginLeft: "22%",
                    marginRight: "22%",
                  }}
                >
                  <h1
                    className="font-ruzicka"
                    style={{
                      fontSize: "42px",
                      textAlign: "center",
                      marginTop: "100px",
                    }}
                  >
                    Correct!
                  </h1>

                  <h2
                    className="font-ruzicka"
                    style={{
                      fontSize: "28px",
                      textAlign: "center",
                    }}
                  >
                    Answer: {currentQuestion.answers[currentQuestion.correct]}
                  </h2>

                  <div
                    style={{
                      display: "inline-block",
                      width: currentQuestion.source ? "75%" : "100%",
                      verticalAlign: "top",
                      fontSize: "20px",
                      marginTop: "20px",
                      marginRight: "20px",
                      height: "145px",
                    }}
                  >
                    {currentQuestion.explanation}
                  </div>
                  {currentQuestion.source ? (
                    <div
                      style={{
                        display: "inline-block",
                        width: "20%",
                        textAlign: "center",
                      }}
                    >
                      <div
                        style={{
                          borderRadius: "50%",
                          background: "#F7F7F7",
                          width: "120px",
                          height: "120px",
                          textAlign: "center",
                        }}
                      >
                        <QRCode
                          style={{
                            top: "-65px",
                            position: "relative",
                            width: "55%",
                            margin: 0,
                          }}
                          bgColor="#F7F7F7"
                          value={currentQuestion.source}
                        />
                      </div>
                      <p
                        style={{
                          fontSize: "14px",
                          fontWeight: "500",
                          margin: 0,
                          marginTop: "6px",
                          width: "100%",
                        }}
                      >
                        Learn more
                      </p>
                    </div>
                  ) : null}
                  <div style={{ textAlign: "center", marginTop: "100px" }}>
                    <button
                      className="font-national"
                      style={{
                        backgroundColor: "#003C73",
                        border: "2px solid #002B52",
                        color: "white",
                        padding: "10px",
                        borderRadius: "20px",
                        fontSize: "20px",
                        cursor: "pointer",
                        width: "300px",
                        height: "70px",
                        fontWeight: "bold",
                      }}
                      onClick={nextQuestion}
                    >
                      {questionIndex === QUIZ_LENGTH - 1
                        ? "Finish"
                        : "Next Question"}
                    </button>
                  </div>
                </div>
              ) : (
                <>
                  <h2
                    className="font-ruzicka"
                    style={{
                      fontSize: "32px",
                      fontWeight: "bold",
                      color: "black",
                      textAlign: "center",
                      // marginBottom: "40px",
                      // height: "100px",
                    }}
                  >
                    {currentQuestion.question}
                  </h2>
                  <div
                    style={{
                      marginTop: "100px",

                      display: "grid",
                      gridTemplateColumns: "repeat(2, 1fr)", // 2 columns
                      gridTemplateRows: "repeat(2, 1fr)", // 2 rows
                      gap: "20px", // Optional: adds spacing between grid items
                      // height: "100vh", // Optional: set the height of the grid container
                    }}
                  >
                    {currentQuestion.answers.map((option, index) => (
                      <button
                        className={
                          showCorrect && index === currentQuestion.correct
                            ? "font-national correctAnswer"
                            : attempted.includes(index)
                            ? "font-national wrongAnswer"
                            : "font-national"
                        }
                        key={index}
                        style={{
                          // padding: "20px",
                          display: "inline-block",
                          height: "80px",

                          // margin: "10px",
                          borderRadius: "20px",
                          textAlign: "center",
                          boxShadow: "5px 5px 5px rgba(172, 172, 172, 0.25)",

                          fontWeight: "bold",
                          borderWidth: "2px",
                          color: "#003C73",
                          borderStyle: "solid",
                          fontSize: "24px",
                          // background:
                          //   showCorrect && index === currentQuestion.correct
                          //     ? "#003C73"
                          //     : "white",
                          // opacity: attempted.includes(index)
                          //   ? index !== currentQuestion.correct
                          //     ? "0.26"
                          //     : "1"
                          //   : "1",
                          borderColor: "#003C73",
                          transition:
                            "opacity 0.4s ease-out, background 0.4s ease-out",
                        }}
                        onClick={() => void makeAttempt(index)}
                      >
                        {option}
                      </button>
                    ))}
                  </div>
                </>
              )}
            </>
          )}
          {/* source */}

          {/* start over button */}
          {/* <button onClick={() => setQuestions([])}>start over</button> */}
        </div>
      ) : (
        // start game screen
        <div
          style={{
            textAlign: "center",
            marginLeft: "5%",
            marginRight: "5%",
            // marginTop: "100px",
          }}
        >
          <fieldset
            style={{
              padding: "20px",
              // width: "100%",
              paddingLeft: "5%",
              paddingRight: "5%",
              paddingBottom: "5%",
              border: "2px solid black",
              position: "relative",
            }}
          >
            <legend>
              <img
                src="/lightbulbs/lit.png"
                style={{
                  width: "80px",
                  marginLeft: "20px",
                  marginRight: "20px",
                }}
                alt="bulb"
              />
            </legend>
            <h1
              style={{
                marginTop: "",
              }}
              className="font-ruzicka"
            >
              Test Your Knowledge
            </h1>

            <ul style={{ textAlign: "left", fontSize: "22px" }}>
              <li>
                Do <strong>YOU</strong> know what kind of fuel powers
                Dartmouth’s co-generation plant?
              </li>
              <li>
                Have <strong>YOU</strong> Ever thought about where New
                Hampshire’s energy comes from?
              </li>
              <li>
                Have <strong>YOU</strong> ever wondered which renewable energy
                source provides the most energy in the United States?
              </li>
            </ul>
            <p
              style={{
                marginTop: "50px",
                fontSize: "22px",
                textAlign: "left",
              }}
            >
              Test your energy knowledge with our fun, interactive game and
              learn a few new fun facts along the way!
            </p>
            {/* <legend
              style={{
                position: "fixed",
                bottom: "25%",
                left: "50%",
                transform: "translate(-50%, 50%)",
                padding: "0 5px",
                // background: "white",
              }}
            > */}
            <div
              style={{
                background: "white",
                // width: "100%",
                position: "absolute",
                transform: "translate(-50%, 50%)",
                marginTop: "50px",
                bottom: "0%",
                width: "410px",
                height: "80px",
                // border: "1px solid black",
                display: "inline",
              }}
            >
              <button
                onClick={startGame}
                className="font-national"
                style={{
                  // position: "fixed",
                  backgroundColor: "#003C73",
                  // padding: "50px",
                  borderRadius: "20px",
                  fontSize: "20px",
                  cursor: "pointer",
                  width: "350px",
                  height: "80px",
                  fontWeight: "bold",
                  color: "white",
                  // marginTop: "50px",
                  // position: "absolute",
                  // transform: "translate(-50%, 50%)",
                  boxShadow:
                    "0px 0px 80px 0px rgba(0, 60, 115, 0.28), 0px 0px 40px 0px #003C73",
                  // bottom: "0%",
                }}
              >
                Let’s go!
              </button>
            </div>
            {/* </legend> */}
          </fieldset>
        </div>
      )}
    </div>
  );
};
